<template>
  <div class="footer" role="contentinfo">
    <div class="footer__container m-l-30 m-r-30">
      <ul class="footer__terms">
        <li><button class="footer__link" @click="openTermsOfUseModal">Terms of Use</button></li>
        <li><button class="footer__link" @click="openPrivacyPolicyModal">Privacy Policy</button></li>
      </ul>

      <div class="footer__title">
        <p>© {{ currentYear }} All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import AppLink from "@/components/base/app-link/AppLink";
import TermsOfUseModal from "@/components/modal/terms-of-use-modal/TermsOfUseModal";
import PrivacyPolicyModal from "@/components/modal/privacy-policy-modal/PrivacyPolicyModal";
import { MIN_DESKTOP_WIDTH } from "@/utils";

export default {
  name: "AppFooter",
  components: {
    TermsOfUseModal,
    PrivacyPolicyModal,
    AppLink
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      lightTheme: "light",
      darkTheme: "dark"
    };
  },
  methods: {
    openTermsOfUseModal() {
      this.$modal.show(
        TermsOfUseModal,
        {},
        window.innerWidth > MIN_DESKTOP_WIDTH
          ? {
              name: "TermsOfUseModal",
              height: "85%",
              width: "70%",
              adaptive: true,
              scrollable: true
            }
          : {
              name: "TermsOfUseModal",
              height: "100%",
              width: "100%",
              adaptive: true,
              scrollable: true
            }
      );
    },
    openPrivacyPolicyModal() {
      this.$modal.show(
        PrivacyPolicyModal,
        {},
        window.innerWidth > MIN_DESKTOP_WIDTH
          ? {
              name: "PrivacyPolicyModal",
              height: "85%",
              width: "70%",
              adaptive: true,
              scrollable: true
            }
          : {
              name: "PrivacyPolicyModal",
              height: "100%",
              width: "100%",
              adaptive: true,
              scrollable: true
            }
      );
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: $footer-height;
  background: $secondary-color;
  font-size: 14px;

  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1250px;

    @include respond-to-mobile {
      flex-direction: column;
      justify-content: center;
      margin: 0;
    }
  }

  &__title {
    color: $primary-color;
  }

  &__terms {
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 10px;
    margin-block-end: 0;

    @include respond-to-mobile {
      padding-left: 0px;
      margin-top: 10px;
    }
  }

  &__link {
    all: unset;
    color: $primary-color !important;
    opacity: 1 !important;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
